<template>
  <div class="details">
    <header></header>
    <div class="modify-company">
      <div class="title">
        <div></div>
        <div>方案信息</div>
      </div>
      <div class="cross">
        <div>公司名称：</div>
        <div>{{clickedDataMsg.solutionContent.solution.companyName || "---" }}</div>
      </div>
      <div class="cross">
        <div>注册地区：</div>
        <div>{{clickedDataMsg.solutionContent.solution.area+"/"+clickedDataMsg.solutionContent.solution.city }}</div>
      </div>
      <div class="cross">
        <div>纳税人类型：</div>
        <div>{{clickedDataMsg.solutionContent.solution.companyCategory || "---" }}</div>
      </div>
      <div class="cross">
        <div>公司性质：</div>
        <div>{{clickedDataMsg.solutionContent.solution.companyType || "---" }}</div>
      </div>
      <div class="cross">
        <div>组织类型：</div>
        <div>{{clickedDataMsg.solutionContent.solution.orgType || "---" }}</div>
      </div>
      <div class="cross">
        <div>从事行业：</div>
        <div>{{clickedDataMsg.solutionContent.solution.industryType || "---" }}</div>
      </div>
      <div class="cross">
        <div>经营范围：</div>
        <div>{{clickedDataMsg.solutionContent.solution.scope || "---" }}</div>
      </div>
      <div class="line"></div>
      <div class="title">
        <div></div>
        <div>方案信息</div>
      </div>
      <div class="cross">
        <div>方案编号：</div>
        <div>{{clickedDataMsg.solutionNo || "---" }}</div>
      </div>
      <div class="cross">
        <div>当前状态：</div>
        <div>{{clickedDataMsg.statusName || "---" }}</div>
      </div>
      <div class="cross">
        <div>方案金额：</div>
        <div>{{clickedDataMsg.solutionContent.totalSum || "---" }}</div>
      </div>
      <div class="cross">
        <div>方案备注：</div>
        <div>{{clickedDataMsg.solutionContent.solution.remark || "---" }}</div>
      </div>
      <div class="cross">
        <div>用户反馈：</div>
        <div>{{clickedDataMsg.solutionContent.notes || "---" }}</div>
      </div>
      <div class="btm-btn">
        <!-- <el-button @click="modifyOrder">提交</el-button> -->
        <!-- <el-button @click="modifyOrder">修改</el-button> -->
        <!-- <el-button>作废</el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import req from "axios";
export default {
  props: ["needNo", "solutionNo", "passHeader"],
  data() {
    return {
      headers: "", // 接口之中需要使用的Headers
      // 需要去呈现装填信息的数据对象
      clickedDataMsg: {
        needNo: "",
        solutionNo: "",
        orderNo: null,
        solutionContent: {
          bizType: "",
          solution: {
            city: "",
            companyName: "",
            park: "",
            registerType: "",
            industryType: "",
            area: "",
            companyType: "",
            productType: "",
            companyCategory: "",
            scope: "",
            orgType: ""
          }
        },
        status: "",
        statusName: ""
      }
    };
  },
  methods: {},
  created() {
    this.headers = this.passHeader;
    console.log(
      "传递过来的needNo:",
      this.needNo,
      "\nsolutionNo:",
      this.solutionNo,
      "\nheaders:",
      this.headers
    );
    req
      .post(
        "/web/action/icapi/springBoard",
        {
          actionType: "getProgrammeInfoByNeedNo",
          actionBody: {
            needNo: this.needNo
          }
        },
        this.headers
      )
      .then(res => {
        console.log("获取详情", res.data);
        if (res.data.status == 0) {
          let thisMsg = res.data.data.filter((item, index) => {
            return item.solutionNo == this.solutionNo;
          });
          this.clickedDataMsg = thisMsg[0];
          console.log("点击的这条数据：", thisMsg, this.clickedDataMsg);
        } else {
          this.$message(res.data.msg);
          console.log("获取详情失败", res.data);
        }
      });
  }
};
</script>
<style lang="scss">
.details {
  header {
    border-bottom: 1px solid #e8e8e8;
  }
  .modify-company {
    .title {
      display: flex;
      height: 38px;
      align-items: flex-end;
      font-size: 14px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      box-sizing: border-box;
      padding-left: 50px;
      > div:nth-child(1) {
        width: 2px;
        margin-right: 6px;
        height: 12px;
        background: rgba(223, 183, 106, 1);
      }
    }
    .line {
      width: 517px;
      border-bottom: 1px dashed #dcdcdc;
      margin-left: 65px;
      margin-top: 26px;
    }
    .cross {
      display: flex;
      margin-top: 24px;
      > div:nth-child(1) {
        width: 143px;
        text-align: right;
        margin-right: 14px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(81, 81, 81, 1);
      }
      > div:nth-child(2) {
        max-width: 424px;
        /* width: 164px; */
        width: 300px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
    .btm-btn {
      margin-top: 22px;
      margin-left: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      > .el-button {
        width: 106px;
        height: 30px;
        background: rgba(223, 183, 106, 1);
        border-radius: 3px;
        padding: 0;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      > .el-button:nth-child(2) {
        width: 106px;
        height: 30px;
        background: rgba(240, 240, 240, 1);
        border-radius: 3px;
        border: none;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
}
</style>